import RequestInstance from '../request.instance';
import { IAddressDailyInioReq, IAddressDistributionInfoReq, IAddressHistoryReq, IAddressHoldingReq } from './smartMoney.request.interface';
import { IAddressDailInfoZone, IAddressDistributionInfo, IAddressHistory, IAddressHolding } from './smartMoney.response.interface';

class SmartMoneyService {
  private readonly requestInstance: RequestInstance;
  constructor() {
    this.requestInstance = new RequestInstance();
  }

  // 获取钱包胜率信息
  async getAddressDistributionInfo(params: IAddressDistributionInfoReq): Promise<IAddressDistributionInfo> {
    return await this.requestInstance.smartMoneyRequest({
      url: `/tx-api/userinfo/distributionInfo`,
      method: 'GET',
      params,
    });
  }

  // 获取钱包收益信息
  async getAddressDailyInfo(params: IAddressDailyInioReq): Promise<IAddressDailInfoZone> {
    return await this.requestInstance.smartMoneyRequest({
      url: `/tx-api/userinfo/dailyInfo`,
      method: 'GET',
      params,
    });
  }

  //  获取钱包持仓信息
  async getAddressHolding(params: IAddressHoldingReq): Promise<IAddressHolding[]> {
    return await this.requestInstance.smartMoneyRequest({
      url: `/tx-api/userinfo/holding`,
      method: 'GET',
      params,
    });
  }

  // 获取钱包交易记录记录
  async getAddressHistory(params: IAddressHistoryReq): Promise<IAddressHistory[]> {
    return await this.requestInstance.smartMoneyRequest({
      url: `/tx-api/userinfo/history`,
      method: 'GET',
      params,
    });
  }
}
export default new SmartMoneyService();
